import * as React from 'react'

export function IconText({
  icon,
  rotate,
  style = { marginRight: 6 },
  text,
}: {
  icon: any
  rotate?: number
  style?: React.CSSProperties
  text: React.ReactNode
}): JSX.Element {
  return (
    <span>
      {React.createElement(icon, { rotate, style })}
      {text}
    </span>
  )
}
